var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "M16.133 1.386c-2.04-1.723-5.169-1.477-7.103.528-1.97-2.005-5.099-2.25-7.138-.528C-.746 3.602-.36 7.224 1.54 9.158l6.154 6.294a1.86 1.86 0 0 0 1.336.563c.492 0 .95-.211 1.301-.563l6.19-6.294c1.863-1.934 2.25-5.556-.388-7.772m-.844 6.576-6.153 6.295c-.07.07-.141.07-.247 0L2.736 7.962c-1.302-1.3-1.548-3.762.246-5.275 1.371-1.16 3.481-.984 4.817.352L9.03 4.305l1.23-1.266c1.302-1.336 3.412-1.512 4.783-.387 1.794 1.548 1.547 4.01.246 5.31"
  })));
};
export default SvgFavorite;